import composeHooks from '../../helpers/composeHooks'

import Navbar, { NavbarProps } from './Navbar'
import useNavbar from './Navbar.hooks'

export type { NavbarProps } from './Navbar'

type ContainerProps = Omit<NavbarProps, 'onBack' | 'clinicName' | 'clinicLogoUrl'>

export default composeHooks<ContainerProps, NavbarProps>({ useNavbar })(Navbar)
